import script from "./statement-notes-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./statement-notes-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__